module.exports = "<template></template>";